import React, { ReactElement } from "react";
import { Table } from "antd";
import { AdsWithoutStateMachineRecord } from "../../../redux/types/reportTypes";

export const columns = [
  {
    title: "Id",
    dataIndex: "id",
  },
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Uuid",
    dataIndex: "uuid",
  },
  {
    title: "Cluster Id",
    dataIndex: "cluster_id",
  },
  {
    title: "Ad Id",
    dataIndex: "ad_id",
  },
  {
    title: "Mp Url",
    dataIndex: "mp_url",
  },
  {
    title: "Status",
    dataIndex: "status",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
  },
  {
    title: "Start Date",
    dataIndex: "start_date",
  },
  {
    title: "End Date",
    dataIndex: "end_date",
  },
  {
    title: "Hashed From",
    dataIndex: "hashed_from",
  },
];

type AdsNoStateMachineTableProps = {
  loading: boolean;
  records: Array<AdsWithoutStateMachineRecord>;
};

const AdsNoStateMachineTable = ({ loading, records }: AdsNoStateMachineTableProps): ReactElement => (
  <Table
    dataSource={records}
    columns={columns}
    loading={loading}
    rowKey="uuid"
    pagination={false}
    scroll={{ y: 350, x: 3200 }}
  />
);

export default AdsNoStateMachineTable;
